import HomeLayout from "../components/home/home-layout";
import LottieLoading from "../components/lottie/lottie-loading";

const LoadingPage: React.FC = () => {
  return (
    <HomeLayout
      children={
        <div className="flex flex-1 p-4 items-center justify-center">
          <LottieLoading />
        </div>
      }
    ></HomeLayout>
  );
};

export default LoadingPage;
